<template>
  <GlobalWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item label="市场" prop="realname" required>
        <el-input v-model="form.realname" placeholder="请输入市场" v-trim/>
      </el-form-item>
      <el-form-item label="登录用户名" prop="account" required>
        <el-input v-model="form.account" placeholder="请输入登录用户名" v-trim/>
      </el-form-item>
      <el-form-item v-if="form.id == null" label="登录密码" prop="password" required>
        <el-input v-model="form.password" placeholder="请输入登录密码" v-trim/>
      </el-form-item>
      <el-form-item label="手机号码" prop="mobile">
        <el-input v-model="form.mobile" placeholder="请输入手机号码" v-trim maxlength="11"/>
      </el-form-item>
      <el-form-item label="邮箱" prop="email">
        <el-input v-model="form.email" placeholder="请输入邮箱" v-trim/>
      </el-form-item>
      <el-form-item label="客户性别" prop="gender">
        <el-radio-group v-model="form.gender">
          <el-radio label="1">男</el-radio>
          <el-radio label="0">女</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
  </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
import { checkMobile, checkEmail, checkLoginUsername } from '@/utils/form'
export default {
  name: 'OperaCustomerWindow',
  extends: BaseOpera,
  components: { GlobalWindow },
  data () {
    return {
      // 表单数据
      form: {
        id: null,
        realname: '',
        mobile: '',
        email: '',
        gender: '1',
        account: '',
        password: ''
      },
      // 验证规则
      rules: {
        realname: [
          { required: true, message: '请输入市场' }
        ],
        mobile: [
          { validator: checkMobile }
        ],
        email: [
          { validator: checkEmail }
        ],
        account: [
          { required: true, message: '请输入登录用户名' },
          { validator: checkLoginUsername }
        ],
        password: [
          { required: true, message: '请输入登录密码' }
        ]
      }
    }
  },
  created () {
    this.config({
      api: '/customer/customer',
      'field.id': 'id'
    })
  }
}
</script>
